module.exports = __webpack_public_path__ + "static/media/ml_logo.3557135a.png";